import _ from 'lodash';
import { CuttingButt } from '../../cutting-butt.model';
import { AngleMode } from '../../cutting-panel-outline.model';
import {
  ChamferBase as IChamfer,
  CountertopAngleProcessingBase as ICountertopAngleProcessing,
  CutBase as ICut,
  CutInsideBase as ICutInside,
  CutInsideWithAngleBase as ICutInsideWithAngle,
  RoundingBase as IRounding,
  RoundingInsideBase as IRoundingInside,
} from './countertop-angle-processing.interface';

export class CountertopAngleProcessing implements ICountertopAngleProcessing {
  mode: AngleMode;
  angleNumber: number;
  parameters?: Rounding | RoundingInside | Cut | CutInside | CutInsideWithAngle | Chamfer;

  reset(type?: AngleMode): void {
    if (_.isNil(type)) {
      this.parameters?.reset();
      return;
    }

    this.mode = type;

    switch (type) {
      case AngleMode.None:
        this.parameters = undefined;
        break;
      case AngleMode.Rounded:
        this.parameters = new Rounding();
        break;
      case AngleMode.Cutted:
        this.parameters = new Cut();
        break;
      case AngleMode.RoundedInside:
        this.parameters = new RoundingInside();
        break;
      case AngleMode.CuttedInside:
        this.parameters = new CutInside();
        break;
      case AngleMode.CuttedInsideWithAngle:
        this.parameters = new CutInsideWithAngle();
        break;
      case AngleMode.Chamfer:
        this.parameters = new Chamfer();
        break;
    }
  }
}

export class Rounding implements IRounding {
  r: number;
  edgeBanding?: CuttingButt;

  constructor() {
    this.reset();
  }

  reset = (): void => {
    this.r = 0;
    this.edgeBanding = undefined;
  };
}

export class RoundingInside implements IRoundingInside {
  r: number;
  edgeBanding?: CuttingButt;

  constructor() {
    this.reset();
  }

  reset = (): void => {
    this.r = 0;
    this.edgeBanding = undefined;
  };
}

export class Cut implements ICut {
  x: number;
  y: number;
  edgeBanding?: CuttingButt;

  constructor() {
    this.reset();
  }

  reset = (): void => {
    this.x = 0;
    this.y = 0;
    this.edgeBanding = undefined;
  };
}

export class CutInside implements ICutInside {
  x: number;
  y: number;
  r: number;
  edgeBanding?: CuttingButt;

  constructor() {
    this.reset();
  }

  reset = (): void => {
    this.x = 0;
    this.y = 0;
    this.r = 0;
    this.edgeBanding = undefined;
  };
}

export class CutInsideWithAngle implements ICutInsideWithAngle {
  x: number;
  y: number;
  r: number;
  y1: number;
  x1: number;
  yA: number;
  xA: number;
  edgeBanding?: CuttingButt;

  constructor() {
    this.reset();
  }

  reset = (): void => {
    this.x = 0;
    this.y = 0;
    this.r = 0;
    this.y1 = 0;
    this.x1 = 0;
    this.yA = 0;
    this.xA = 0;
    this.edgeBanding = undefined;
  };
}

export class Chamfer implements IChamfer {
  length: number;
  edgeBanding?: CuttingButt;

  constructor() {
    this.reset();
  }

  reset = (): void => {
    this.length = 0;
    this.edgeBanding = undefined;
  };
}
